import { styled } from "@mui/material/styles";

export const GridContainer = styled("div")(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, 120px)",
  justifyContent: "flex-start",
  gap: theme.spacing(2),
  width: "100%",
  boxSizing: "border-box",
}));
